import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Box, Button, colors, FormControlLabel, IconButton, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { reFormatDate } from "../../../../utils/utils";
import { Delete, Search } from "@material-ui/icons";
import { useStylesAutoBlack, useStylesLbl, useStylesTF, useStylesUiElemment } from "../../../../St/Reports/UseStyle";
import { Autocomplete } from "@material-ui/lab";
import i18next from "i18next";
import { SaleCheckbox } from "../../../../St/comps/UseStyle";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));
export const mathsTax = (rTotAfterDic, taxperc, ty) => {
    if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
    if (ty === "Net")
        return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
    if (ty === "before_vat") return rTotAfterDic.toFixed(2);
};
export default function RestrictionTable(props) {
    const { paramsList, setParamsList, AutoOptions, setConfirmDialog,
        prevent, openUpdate, centers, Accounts, setRowUpdate, IsOpen, handleIconSearchAccount
        , searchAccountText, handleInputSearchAccount, accountsOptions, addnewSearch
    } = props;

    const stylRo2 = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontSize: 14,
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        width: "270px",
        maxWidth: "270px",
        minWidth: "200px",
        color: "#000"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }
    const handleFocus = (e) => e.target.select();
    const [rowItem, setRowItem] = useState({});

    const onRowDelete = async (rowdata) => {
        if (!prevent && !openUpdate) return;
        var newData = paramsList.filter((obj) => obj.no !== rowdata.no);
        const newItems = newData.map((row, i) => {
            return {
                ...row,
                no: i,
            };
        });
        setParamsList([...newItems]);
        setConfirmDialog(false);
    };
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();
    const onRowClick = (row) => {
        setRowUpdate(row);
    };
    const handleOpenUpdate = (props, e, row) => {
        if (!prevent && !openUpdate) return;

        var newDataDept = paramsList.filter((obj) => obj.editDept === true);
        var newDataCredit = paramsList.filter((obj) => obj.editCredit === true);
        var newDataCenter = paramsList.filter((obj) => obj.editCenter === true);
        var newDataNotes = paramsList.filter((obj) => obj.editNotes === true);
        var newDataRefNo = paramsList.filter((obj) => obj.editRef_no === true);
        var newDataAcc_no = paramsList.filter((obj) => obj.edit_acc_no === true);
        var newDataOmla = paramsList.filter((obj) => obj.editOmla === true);
        var newDataDate = paramsList.filter((obj) => obj.editDate === true);

        if (rowItem?.no != null) {
            if (rowItem.no == row.no) {
                if (newDataDept.length != 0 && props !== "dept") {
                    EnterChangeTtems("dept", rowItem, row);
                } else if (newDataCredit.length != 0 && props !== "credit") {
                    EnterChangeTtems("credit", rowItem, row);
                }
                else if (newDataCenter.length != 0 && props !== "center") {
                    EnterChangeTtems("center", rowItem, row);
                    setRowItem({});
                } else if (newDataNotes.length != 0 && props !== "notes") {
                    EnterChangeTtems("notes", rowItem, row);
                }
                else if (newDataRefNo.length != 0 && props !== "ref_no") {
                    EnterChangeTtems("ref_no", rowItem, row);
                }
                else if (newDataAcc_no.length != 0 && props !== "acc_no") {
                    EnterChangeTtems("acc_no", rowItem, row);
                    setRowItem({});
                }
                else if (newDataOmla.length != 0 && props !== "omla") {
                    EnterChangeTtems("omla", rowItem, row);
                    setRowItem({});
                }
                else if (newDataDate.length != 0 && props !== "RestDate") {
                    EnterChangeTtems("RestDate", rowItem, row);
                    // setRowItem({});
                }
            }
            else {
                if (newDataDept.length != 0 && props !== "dept") {
                    EnterChangeTtems("dept", rowItem, row);
                } else if (newDataCredit.length != 0 && props !== "credit") {
                    EnterChangeTtems("credit", rowItem, row);
                }
                else if (newDataCenter.length != 0 && props !== "center") {
                    EnterChangeTtems("center", rowItem, row);
                } else if (newDataNotes.length != 0 && props !== "notes") {
                    EnterChangeTtems("center", rowItem, row);
                    setRowItem({});
                }
                else if (newDataRefNo.length != 0 && props !== "ref_no") {
                    EnterChangeTtems("ref_no", rowItem, row);
                }
                else if (newDataAcc_no.length != 0 && props !== "acc_no") {
                    EnterChangeTtems("acc_no", rowItem, row);
                    setRowItem({});
                }
                else if (newDataOmla.length != 0 && props !== "omla") {
                    EnterChangeTtems("omla", rowItem, row);
                    setRowItem({});
                }
                else if (newDataDate.length != 0 && props !== "RestDate") {
                    EnterChangeTtems("RestDate", rowItem, row);
                }
            }
        } else {
            if (props === "dept") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editDept: true,
                };
                setParamsList([...dataUpdate]);

            } else if (props === "credit") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editCredit: true,
                };
                setParamsList([...dataUpdate]);
            }
            else if (props === "center") {

                e.preventDefault();
                let defCenter = { id: row.center, name: row.centerView }
                setRowItem({ ...row, defCenter: defCenter });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editCenter: true,
                };
                setParamsList([...dataUpdate]);
            }
            else if (props === "acc_no") {

                e.preventDefault();
                let defAcc_no = { id: row.acc_no, name: row.acc_name }
                setRowItem({ ...row, defAcc_no: defAcc_no, });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    edit_acc_no: true,
                };
                setParamsList([...dataUpdate]);
            }
            else if (props === "omla") {

                e.preventDefault();
                let defOmla = AutoOptions?.omlats.find((obj) => obj.id === row.omla);
                setRowItem({ ...row, defOmla: defOmla, });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editOmla: true,
                };
                setParamsList([...dataUpdate]);
            }
            else if (props === "notes") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editNotes: true,
                };
                setParamsList([...dataUpdate]);
            }
            else if (props === "ref_no") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editRef_no: true,
                };
                setParamsList([...dataUpdate]);
            }
            else if (props === "RestDate") {
                e.preventDefault();
                setRowItem({ ...row, RestDate: reFormatDate(row?.RestDate) });
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    editDate: true,
                };
                setParamsList([...dataUpdate]);
            }
        }

    };

    const MathChangIdataTtems = (prop, row) => (event) => {
        setRowItem({
            ...rowItem,
            [prop]: event.target.value,
        });
    };
    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            dept: Number(rowItem.dept),
            credit: Number(rowItem.credit),
        };
        const index = row?.no;
        const dataUpdate = [...paramsList];
        dataUpdate[index] = {
            ...rowItem,
            dept: i.dept,
            credit: i.credit,
            editDept: false,
            editCredit: false,
            editCenter: false,
            editNotes: false,
            editRef_no: false,
            edit_acc_no: false,
            editOmla: false,
            editDate: false,
        };

        if (row.useTax === 1) {
            let acc_tax = null;
            if (parseFloat(row.dept) > 0) {
                acc_tax = Accounts.MedAccount.find((x) => x.namePro === "TaxPurches");
            } else {
                acc_tax = Accounts.MedAccount.find((x) => x.namePro === "TaxSales");
            }
            const index2 = row?.no + 1;
            let row_tax = paramsList.find((x) => x.no === index2)
            if (acc_tax != null && Number(row_tax.acc_no) == Number(acc_tax.id)) {
                dataUpdate[index2] = {
                    ...row_tax,
                    dept: parseFloat(i.dept) > 0 ? mathsTax(parseFloat(i.dept), parseFloat(15), "taxval") : 0,
                    credit: parseFloat(i.dept) > 0 ? 0 : mathsTax(parseFloat(i.credit), parseFloat(15), "taxval"),
                };
            }
            setParamsList([...dataUpdate]);
            setRowItem({});
        } else {
            setParamsList([...dataUpdate]);
            setRowItem({});
        }
    };

    const changAutoCurrUnits = (row, newValue) => {
        const index = row?.no;
        const dataUpdate = [...paramsList];
        dataUpdate[index] = {
            ...row,
            center: newValue.id,
            centerView: newValue.name,
            editCenter: false,
        };
        setParamsList([...dataUpdate]);
        setRowItem({});

    };

    const changAutoAcc_no = (row, newValue) => {
        const index = row?.no;
        const dataUpdate = [...paramsList];
        dataUpdate[index] = {
            ...row,
            acc_no: newValue.id,
            acc_name: newValue.name,
            name: newValue.name,
            edit_acc_no: false,
        };
        setParamsList([...dataUpdate]);
        setRowItem({});
        addnewSearch(newValue);
    };
    const changAutoOmla = (row, newValue) => {
        const index = row?.no;
        const dataUpdate = [...paramsList];
        dataUpdate[index] = {
            ...row,
            omla: newValue.id,
            omlaval: newValue.exchange,
            omlaName: newValue.name,
            exchange: newValue.exchange,
            editOmla: false,
        };
        setParamsList([...dataUpdate]);
        setRowItem({});

    };

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const containerRef = useRef(null);
    const getcheckWithTax = async (row, event) => {
        let acc_tax = null;
        if (parseFloat(row.dept) > 0) {
            acc_tax = Accounts.MedAccount.find((x) => x.namePro === "TaxPurches");
        } else {
            acc_tax = Accounts.MedAccount.find((x) => x.namePro === "TaxSales");
        }
        if (acc_tax != null) {
            if (event === true) {

                const newAcc = {
                    ...row,
                    no: row.no + 1,
                    acc_no: acc_tax.id,
                    acc_name: acc_tax.name,
                    name: acc_tax.name,
                    useTax: 0,
                    dept: parseFloat(row.dept) > 0 ? mathsTax(parseFloat(row.dept), parseFloat(15), "taxval") : 0,
                    credit: parseFloat(row.dept) > 0 ? 0 : mathsTax(parseFloat(row.credit), parseFloat(15), "taxval"),
                }
                const index = row?.no;
                const dataUpdate = [...paramsList, newAcc];
                dataUpdate[index] = {
                    ...row,
                    useTax: 1,
                };
                setParamsList([...dataUpdate].sort((a, b) => a.no - b.no));
            } else {
                const index = row?.no;
                const dataUpdate = [...paramsList];
                dataUpdate[index] = {
                    ...row,
                    useTax: 0,
                };
                const newData = dataUpdate.filter((obj) => obj.no !== row.no + 1);
                setParamsList([...newData]);
            }
        }
    }
    // useEffect(() => {
    //     if (containerRef.current  ) {
    //         if (prevent || (!prevent && openUpdate))
    //         containerRef.current.scrollTop = containerRef.current.scrollHeight;
    //     }
    // }, [paramsList]);
    return (
        <TableContainer component={Paper}
            // style={{ minHeight: 370, }}
            style={{
                minHeight: "24vw", maxHeight: "24vw", direction: i18next.language == "ar" ? "rtl" : "ltr"
            }}
        // ref={containerRef}
        >
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: colors.grey[700],
                            color: "#fff",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {""}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("account-code")}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("account")}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("dept")}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("credit")}{" "}
                        </TableCell>
                        {!IsOpen &&
                            <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                                {"استخدام الضريبة"}
                            </TableCell>}
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("مدين محلي")}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("دائن محلي")}{" "}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("currency")}{" "}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("curr-exchange")}{" "}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("center")}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("ref-no")}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("date")}{" "}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {t("note")}{" "}
                        </TableCell>
                        <TableCell style={{ color: "#fff", fontWeight: "bold" }} align="center">
                            {"Action"}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paramsList.map((row, i) => (
                        <TableRow key={row.no}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.no + 1}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.acc_no}</TableCell>
                            <TableCell style={stylRo2} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("acc_no", event, row)}>

                                {
                                    row?.edit_acc_no ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasAo}
                                            value={rowItem.defAcc_no}
                                            onFocus={handleFocus}
                                            id="combo-box-demo"
                                            onInputChange={(event, newValue, reason) => {
                                                if (reason === "input") handleInputSearchAccount(event, newValue, reason);
                                            }}
                                            options={accountsOptions}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            onBlur={(e) => EnterChangeTtems("acc_no", rowItem, row)}
                                            disableClearable={true}
                                            style={{ backgroundColor: colors.green[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <Box size="small" display={"flex"} textAlign={"center"}>
                                                    <TextField
                                                        {...params}
                                                        label={""}
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        textAlign={"center"}
                                                        InputLabelProps={{ className: claslbl.clrSafe }}
                                                    />
                                                    {searchAccountText != "" &&
                                                        (
                                                            <IconButton size="small" onClick={handleIconSearchAccount}>
                                                                <Search />
                                                            </IconButton>
                                                        )}
                                                </Box>
                                            )}
                                            onChange={(event, newValue) => {
                                                changAutoAcc_no(row, newValue);
                                            }}
                                        />
                                    ) :
                                        (
                                            row?.acc_name
                                        )

                                }

                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("dept", event, row)}>
                                {
                                    row.editDept && row.credit == 0 ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="dept"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="dept"
                                                    onBlur={(e) => EnterChangeTtems("dept", rowItem, row)}
                                                    value={rowItem.dept}
                                                    onChange={MathChangIdataTtems("dept", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("dept", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("dept", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.dept)
                                        )}
                            </TableCell>

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("credit", event, row)}>

                                {
                                    row.editCredit && row.dept == 0 ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="dept"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="dept"
                                                    onBlur={(e) => EnterChangeTtems("credit", rowItem, row)}
                                                    value={rowItem.credit}
                                                    onChange={MathChangIdataTtems("credit", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("credit", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("credit", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.credit)
                                        )}
                            </TableCell>
                            {!IsOpen &&
                                <TableCell style={stylRo} align="center">
                                    <FormControlLabel
                                        id="showPaid"
                                        value="addProfSalary"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={row.useTax == 1}
                                                onChange={(e) => {
                                                    getcheckWithTax(row, e.target.checked);
                                                }}
                                                color={"#f18584"}
                                            />
                                        }
                                        label=""
                                        disabled={parseFloat(row.dept) == 0 && parseFloat(row.credit) == 0}
                                        labelPlacement="end"
                                    />
                                </TableCell>}

                            <TableCell style={stylRo} align="center">
                                {(Number(row.dept) * Number(row.omlaval)).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center">
                                {(Number(row.credit) * Number(row.omlaval)).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("omla", event, row)}>

                                {
                                    row?.editOmla && AutoOptions?.omlats.length > 0 ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasAo}
                                            value={rowItem.defOmla}
                                            onFocus={handleFocus}
                                            onChange={(event, newValue) => {
                                                changAutoOmla(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={AutoOptions?.omlats}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            onBlur={(e) => EnterChangeTtems("omla", rowItem, row)}
                                            disableClearable={true}
                                            style={{ backgroundColor: colors.green[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={""}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbl.clrSafe }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row?.omlaName
                                        )

                                }

                            </TableCell>
                            <TableCell style={stylRo} align="center">
                                {(Number(row.exchange)).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("center", event, row)}>

                                {
                                    row?.editCenter ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasAo}
                                            value={rowItem.defCenter}
                                            onFocus={handleFocus}
                                            onChange={(event, newValue) => {
                                                changAutoCurrUnits(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={centers}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            onBlur={(e) => EnterChangeTtems("center", rowItem, row)}
                                            disableClearable
                                            style={{ backgroundColor: colors.green[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t("center")}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbl.clrSafe }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row?.centerView
                                        )

                                }

                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("ref_no", event, row)}>
                                {
                                    row.editRef_no ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="ref_no"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="text"
                                                    name="ref_no"
                                                    onBlur={(e) => EnterChangeTtems("ref_no", rowItem, row)}
                                                    value={rowItem.ref_no}
                                                    onChange={MathChangIdataTtems("ref_no", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("ref_no", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("ref_no", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            row.ref_no
                                        )}
                            </TableCell>
                            {/* <TableCell style={stylRo} align="center">{reFormatDate(row?.RestDate)}</TableCell> */}

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("RestDate", event, row)}>

                                {
                                    row.editDate && !IsOpen ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="RestDate"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="date"
                                                    name="RestDate"
                                                    format="YYYY-MM-DD"
                                                    onBlur={(e) => EnterChangeTtems("RestDate", rowItem, row)}
                                                    value={rowItem.RestDate}
                                                    onChange={MathChangIdataTtems("RestDate", row)}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("RestDate", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("RestDate", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            reFormatDate(row?.RestDate)
                                        )}
                            </TableCell>

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("notes", event, row)}>
                                {
                                    row.editNotes ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="notes"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="text"
                                                    name="notes"
                                                    onBlur={(e) => EnterChangeTtems("notes", rowItem, row)}
                                                    value={rowItem.notes}
                                                    onChange={MathChangIdataTtems("notes", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("notes", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("notes", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            row.notes
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={(e) => {
                                        if (!prevent && !openUpdate) {

                                        } else {
                                            setConfirmDialog({
                                                isOpen: true,
                                                onConfirm: () => {
                                                    onRowDelete(row);
                                                },
                                            })
                                        }
                                    }}
                                >
                                    <Delete size={"small"} />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
